import { useCallback, useEffect } from "react";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import SnackMessage from "./SnackMessage";

export default function SnackAlert() {
  const { enqueueSnackbar } = useSnackbar();
  const { alertMessage, alertType } = useSelector((state) => state.common);

  const renderContent = useCallback(
    (key) => <SnackMessage id={key} message={alertMessage} variant={alertType} />,
    [alertMessage, alertType]
  );

  useEffect(() => {
    if (alertMessage != null) {
      enqueueSnackbar(null, { content: renderContent });
    }
  }, [alertMessage, alertType, enqueueSnackbar, renderContent]);

  return null;
}